/* eslint-disable */
import React, { useState, useContext, useEffect, useCallback, useRef } from "react";
import { makeStyles } from "@material-ui/core/styles";
import GridContainer from "components/Grid/GridContainer";
import CardContent from "@material-ui/core/CardContent";
import GridItem from "components/Grid/GridItem";
import CardHeader from "../../../components/Card/CardHeader.js";
import Card from "../../../components/Card/Card.js";
import Button from "components/CustomButtons/Button";
import PerfectScrollbar from "react-perfect-scrollbar";
import "react-perfect-scrollbar/dist/css/styles.css";
import Tooltip from "@material-ui/core/Tooltip";
import EditSectionModal from "../../../components/EditSectionModal/EditSectionModal.js";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCalendarPlus,
  faCalendarMinus,
  faTable,
  faChartLine,
  faChartSimple,
  faExclamationTriangle,
  faFilter,
} from "@fortawesome/free-solid-svg-icons";
import CardBody from "components/Card/CardBody.js";
import dayjs from "dayjs";

import {
  Announcement,
  DoubleArrow,
  Visibility,
  Edit,
  AttachMoney,
  Info,
  Assessment,
  Close,
} from "@material-ui/icons";
import CardIcon from "components/Card/CardIcon.js";
import { cardTitle } from "assets/jss/material-dashboard-pro-react.js";
import AuthContext from "contexts/AuthProvider.js";
import customSelectStyle from "assets/jss/material-dashboard-pro-react/customSelectStyle.js";
import customInputStyle from "assets/jss/material-dashboard-pro-react/components/customInputStyle";
import { grayColor } from "assets/jss/material-dashboard-pro-react.js";
import Tippy from "@tippyjs/react";
import "tippy.js/dist/tippy.css";
import { useTranslation } from "react-i18next";
import { formatThresholds } from "utils/thresholdUtils";

import {
  Checkbox,
  FormControlLabel,
} from "@material-ui/core";
import { CheckCircle, RadioButtonUnchecked } from "@material-ui/icons";
import { client } from "../../../services/axiosClient.js";
import { ThreeDots } from "react-loader-spinner";
import OverviewTableV3 from "./AuxComponents/OverviewTableV3.js";
import { Chip } from "@material-ui/core";
import MultiSeriesLineChartvBAR from "./AuxComponents/MultiSeriesLineChartvBAR2.js";
import ReactSelect from "react-select";
import initiativeManagementStyle from "assets/jss/material-dashboard-pro-react/views/initiativesManagementStyle.js";
import AIAssistant from "./AuxComponents/AIAssistant.js";
import InitiativeDetailsDialog from "./AuxComponents/InitiativeDetailsDialog.js";

// Function to render priority chip
function getPriorityChip(priority, clientColor) {
  switch (priority) {
    case "High":
      return (
        <Chip
          label="HIGH"
          style={{
            backgroundColor: "#f44336",
            color: "#fff",
            fontWeight: "bold",
          }}
          size="small"
        />
      );
    case "Medium":
      return (
        <Chip
          label="MEDIUM"
          style={{
            backgroundColor: "#ffeb3b",
            color: "#333",
            fontWeight: "bold",
          }}
          size="small"
        />
      );
    case "Low":
      return (
        <Chip
          label="LOW"
          style={{
            backgroundColor: "#4caf50",
            color: "#fff",
            fontWeight: "bold",
          }}
          size="small"
        />
      );
    default:
      return (
        <Chip
          label="UNDEFINED"
          style={{
            backgroundColor: "#9e9e9e",
            color: "#fff",
          }}
          size="small"
        />
      );
  }
}

// ----Main component -----------------------------------------
export default function WhatsHappeningV8() {
  const { userDetails } = useContext(AuthContext);
  const clientColor = userDetails?.implementation_color;
  const defaultKpiId = userDetails?.status_kpi_id || 1;

  // ----STATE MANAGEMENT ----
  const [sections, setSections] = useState([]);
  const [selectedSectionId, setSelectedSectionId] = useState(null);
  const [decisions, setDecisions] = useState([]);
  const [initiatives, setInitiatives] = useState([]);
  const [kpis, setKpis] = useState({});

  // States for chart/timeAgg
  const [timeAggGraph1, setTimeAggGraph1] = useState("monthly");
  const [viewModeGraph1, setViewModeGraph1] = useState("chart");
  
  // States for chart filters (branch and workfront)
  const [chartFilterBranch, setChartFilterBranch] = useState("");
  const [chartFilterWorkfront, setChartFilterWorkfront] = useState("");

  // Additional states
  const [isLoadingKpis, setIsLoadingKpis] = useState(true);
  const [isLoadingKpisFromFilter, setIsLoadingKpisFromFilter] = useState(false); // Loading apenas quando filtro muda
  const [isLoadingSections, setIsLoadingSections] = useState(true);
  const [viewModeOverview, setViewModeOverview] = useState("stages");
  const [isModalOpen, setIsModalOpen] = useState(false);

  const [selectedInitiative, setSelectedInitiative] = useState(null);
  const [isInitiativeDrawerOpen, setIsInitiativeDrawerOpen] = useState(false);
  const [isLoadingInitiativeDetail, setIsLoadingInitiativeDetail] = useState(false);

  // State para o AI Assistant
  const [isAssistantOpen, setIsAssistantOpen] = useState(false);

  // Loading states adicionais
  const [isLoadingOverview, setIsLoadingOverview] = useState(true);
  const [kpiOverviewData, setKpiOverviewData] = useState([]);
  const [stageChoices, setStageChoices] = useState([]);

  // Hook for styles + i18n
  const useStylesCustom = makeStyles((theme) =>
    WhatsHappeningStyles(theme, clientColor)
  );

  const classes = useStylesCustom();
  const { t } = useTranslation();

  /* ——— React‑Select skin ——— */
  const customStyles = {
    control: (prov, state) => ({
      ...prov,
      minHeight: "80px",
      maxHeight: "80px",
      overflowY: "auto",
      borderColor: state.isFocused ? clientColor : prov.borderColor,
      backgroundColor: "white",
      "&:hover": { borderColor: clientColor },
    }),
    menu: (prov) => ({ ...prov, overflowY: "auto", backgroundColor: "white" }),
    option: (prov, state) => ({
      ...prov,
      color: state.isSelected ? "black" : state.isFocused ? "white" : "black",
      backgroundColor: state.isSelected
        ? "gray"
        : state.isFocused
          ? clientColor
          : "white",
      "&:active": {
        transform: "scale(0.95)",
        transition: "transform 0.2s ease",
        backgroundColor: clientColor,
      },
    }),
    multiValue: (prov) => ({ ...prov, backgroundColor: "#d3d3d3" }),
    multiValueLabel: (prov) => ({ ...prov, color: "black" }),
    multiValueRemove: (prov) => ({
      ...prov,
      color: "black",
      ":hover": { backgroundColor: "red", color: "white" },
    }),
  };

  // Ref para rastrear se já fez o primeiro carregamento do KPI
  const hasInitialKpiLoadRef = useRef(false);
  
  // -------------- useEffect: Buscar KPI no backend -------------
  useEffect(() => {
    async function fetchKpis() {
      if (!defaultKpiId) {
        setIsLoadingKpis(false);
        return;
      }
      
      try {
        // Primeiro carregamento usa isLoadingKpis, carregamentos subsequentes (filtros) usam isLoadingKpisFromFilter
        if (!hasInitialKpiLoadRef.current) {
          setIsLoadingKpis(true);
        } else {
          setIsLoadingKpisFromFilter(true);
        }
        
        // Build request payload with optional filters
        const payload = {
          action: "list",
          kpi_ids: [defaultKpiId],
        };
        
        // Add filters if they are set
        if (chartFilterBranch) {
          payload.branch = chartFilterBranch;
        }
        if (chartFilterWorkfront) {
          payload.workfront = chartFilterWorkfront;
        }
        
        const response = await client.post("/api/whatshappening-kpi-data/", payload);
        if (response.data.success) {
          setKpis(response.data.kpis);
          hasInitialKpiLoadRef.current = true; // Marca que o primeiro carregamento foi feito
        }
      } catch (err) {
        // console.error("Error fetching main KPI data:", err);
      } finally {
        setIsLoadingKpis(false);
        setIsLoadingKpisFromFilter(false);
      }
    }
    fetchKpis();
  }, [defaultKpiId, chartFilterBranch, chartFilterWorkfront]);

  // -------------- useEffect: Buscar Overview data do KPI -------------
  // POR-13 usa API customizada; outros clientes usam API padrão
  useEffect(() => {
    async function fetchKpiOverview() {
      // Wait for userDetails to be loaded
      if (!userDetails) {
        setIsLoadingOverview(false);
        return;
      }
      
      try {
        setIsLoadingOverview(true);
        
        // POR-13 (Portobello) tem implementation_id = 13
        const useCustomAPI = userDetails?.implementation_id === 13;
        
        let response;
        if (useCustomAPI) {
          // API customizada para POR-13
          response = await client.post(
            "/api/custom-stage-overview-data/",
            {
              action: "list",
            }
          );
        } else {
          // API padrão para outros clientes
          if (!defaultKpiId) {
            setIsLoadingOverview(false);
            return;
          }
          response = await client.post(
            "/api/whatshappening-overview-data/",
            {
              action: "list",
              kpi_id: defaultKpiId,
            }
          );
        }
        
        if (response.data.success) {
          setKpiOverviewData(
            response.data.data.map((it) => ({
              ...it,
              status: (it.status || "gray").toLowerCase(),
            }))
          );
          setStageChoices(response.data.stage_choices);
        }
      } catch (err) {
        // console.error("Request failed for overview data:", err);
      } finally {
        setIsLoadingOverview(false);
      }
    }
    fetchKpiOverview();
  }, [defaultKpiId, userDetails]);

  // -------------- Carregar Sections + Decisions --------------
  useEffect(() => {
    async function loadInitiatives() {
      try {
        const response = await client.get("/api/decision-initiatives-list/");
        if (response.data.success) {
          setInitiatives(response.data.initiatives);
        }
      } catch (error) {
        // console.error("Error loading initiatives: ", error);
      }
    }
    loadInitiatives();
  }, []);

  useEffect(() => {
    async function loadSectionsAndDecisions() {
      try {
        setIsLoadingSections(true);
        const response = await client.post(
          "/api/control-panel-sections-decisions/",
          {
            action: "list",
          }
        );
        if (response.data.success) {
          setSections(response.data.sections || []);
          setDecisions(response.data.decisions || []);
        }
      } catch (err) {
        // console.error(err);
      } finally {
        setIsLoadingSections(false);
      }
    }
    loadSectionsAndDecisions();
  }, []);

  // "isLoading" geral
  const isLoading = isLoadingKpis || isLoadingSections || isLoadingOverview;

  // -------------- Escolher a section com end_date mais próxima -------------
  useEffect(() => {
    if (sections.length > 0) {
      const closestSection = getClosestSectionToToday(sections);
      if (closestSection) {
        setSelectedSectionId(closestSection.id);
      } else {
        setSelectedSectionId(sections[0].id);
      }
    }
  }, [sections]);

  // -------------- handleDecisionToggle -------------
  const handleDecisionToggle = async (decisionId, checked) => {
    try {
      const payload = {
        action: "updateDecision",
        id: decisionId,
        done: checked,
      };
      const response = await client.post(
        "/api/control-panel-sections-decisions/",
        payload
      );
      if (response.status !== 200) {
        throw new Error("Failed to update decision");
      }
      const data = response.data;
      if (data.success) {
        setDecisions((prev) =>
          prev.map((dec) =>
            dec.id === decisionId ? { ...dec, done: checked } : dec
          )
        );
      }
    } catch (error) {
      // console.error("Error toggling decision:", error);
    }
  };

  // -------------- Carregar iniciativa  -------------
  const handleInitiativeClick = async (initiativeId) => {
    try {
      setIsLoadingInitiativeDetail(true);
      setSelectedInitiative(null);
      const response = await client.post("/api/initiative-detail/", {
        action: "detail",
        initiative_id: initiativeId,
      });
      if (response.data && response.data.success) {
        setSelectedInitiative(response.data.initiative);
        setIsInitiativeDrawerOpen(true);
      }
    } catch (error) {
      // console.error("Erro no handleInitiativeClick:", error);
    } finally {
      setIsLoadingInitiativeDetail(false);
    }
  };

  // -------------- States e Handlers para KPI da Iniciativa  -------------
  const [initiativeKpisData, setInitiativeKpisData] = useState(null);
  const [isKpiLoading, setIsKpiLoading] = useState(false);
  const [kpiError, setKpiError] = useState(null);

  // ONE PAGE STATES
  const [currentOnePage, setCurrentOnePage] = useState(null);
  const [isLoadingOnePage, setIsLoadingOnePage] = useState(false);
  const [onePageError, setOnePageError] = useState(null);

  const [selectedTabIndex, setSelectedTabIndex] = React.useState(0);

  // >>> useEffect para buscar dados de KPIs quando a iniciativa é selecionada:
  useEffect(() => {
    async function fetchKpiData() {
      try {
        if (!selectedInitiative?.id) {
          setInitiativeKpisData(null);
          return;
        }
        setIsKpiLoading(true);
        setKpiError(null);

        const response = await client.post("/api/initiative-results-data/", {
          action: "list",
          initiative_id: selectedInitiative.id,
        });

        if (response.data.success) {
          setInitiativeKpisData(response.data.data);
        } else {
          setKpiError(response.data.error || "Failed to fetch KPI data");
        }
      } catch (err) {
        setKpiError("Could not contact the server");
      } finally {
        setIsKpiLoading(false);
      }
    }

    fetchKpiData();
  }, [selectedInitiative]);

  // >>> Refactored function to fetch OnePage data
  const fetchOnePageData = useCallback(async (initiativeId) => {
    if (!initiativeId) {
      setCurrentOnePage(null);
      return;
    }
    try {
      setIsLoadingOnePage(true);
      setOnePageError(null);

      const response = await client.post("/api/whatshappening-onepage/", {
        initiative_id: initiativeId,
      });

      if (response.data.success) {
        setCurrentOnePage(response.data.onepage_data);
      } else {
        setOnePageError(response.data.error || "Failed to fetch OnePage data");
        setCurrentOnePage(null);
      }
    } catch (err) {
      setOnePageError("Could not contact the server");
      setCurrentOnePage(null);
    } finally {
      setIsLoadingOnePage(false);
    }
  }, []);

  useEffect(() => {
    if (selectedInitiative?.id) {
      fetchOnePageData(selectedInitiative.id);
    } else {
      setCurrentOnePage(null);
    }
  }, [selectedInitiative, fetchOnePageData]);

  // -------------- Aux function to find closest section -------------
  function getClosestSectionToToday(sectionsArray) {
    const today = dayjs();
    let closestSection = null;
    let minDiff = Infinity;
    for (const section of sectionsArray) {
      if (!section.end_date) continue;
      const diffAbs = Math.abs(dayjs(section.end_date).diff(today, "days"));
      if (diffAbs < minDiff) {
        minDiff = diffAbs;
        closestSection = section;
      }
    }
    return closestSection;
  }

  // -------------- Toggling "Monthly"/"Yearly" + "chart"/"table" -------------
  const toggleTimeAggGraph1 = () => {
    setTimeAggGraph1((prev) => (prev === "monthly" ? "yearly" : "monthly"));
  };
  const toggleViewModeGraph1 = () => {
    setViewModeGraph1((prev) => (prev === "chart" ? "table" : "chart"));
  };


  const toggleViewModeOverview = () => {
    if (viewModeOverview === "table") {
      setViewModeOverview("stages");
    } else if (viewModeOverview === "stages") {
      setViewModeOverview("drilldown");
    } else {
      setViewModeOverview("table");
    }
  };

  // -------------- Modal -------------
  const handleOpenModal = () => {
    setIsModalOpen(true);
  };
  const handleCloseModal = () => {
    setIsModalOpen(false);
  };

  const handleToggleAssistant = () => {
    setIsAssistantOpen((prev) => !prev);
  };

  // -------------- Some style definitions -------------
  const selectedSection = sections.find((s) => s.id === selectedSectionId);

  // -------------- KPI extraído do backend -------------
  const mainKPI = kpis[String(defaultKpiId)];

  // Dados para o gráfico
  const chartDataGraph1 = mainKPI?.data?.[timeAggGraph1] || null;

  // -------------- Floating Card -------------
  const renderFloatingCard = () => {
    const selectedSec = sections.find((s) => s.id === selectedSectionId);
    if (!selectedSec) return null;

    return (
      <div className={classes.floatingCard}>
        <div className={classes.floatingCardTitle}>
          {selectedSec.section_name}
          <span style={{ marginLeft: 2, fontSize: "12px", color: "#666" }}>
            | {t("whatshappening.card_footer.period")}{" "}
            {selectedSec.start_date || "?"} -&gt; {selectedSec.end_date || "?"}
          </span>
        </div>
        <Tooltip title={t("program_meeting.actions.edit_section")}>
          <Edit
            className={classes.iconButtonCustom}
            onClick={handleOpenModal}
            style={{
              cursor: "pointer",
              fontSize: "20px",
            }}
          />
        </Tooltip>
        <EditSectionModal
          open={isModalOpen}
          handleClose={handleCloseModal}
          sections={sections}
          setSelectedSectionId={setSelectedSectionId}
          clientColor={clientColor}
        />
      </div>
    );
  };

  // -------------- Styles function -------------
  function WhatsHappeningStyles(theme, cColor) {
    return {
      ...initiativeManagementStyle(theme, clientColor),
      ...customSelectStyle(theme, cColor),
      ...customInputStyle(cColor),
      root: {
        padding: 0,
        margin: 0,
      },
      cardIconTitle: {
        ...cardTitle,
        marginTop: "0px",
        marginBottom: "0px",
        padding: "10px",
        fontSize: "15px",
      },
      cardButton: {
        padding: "0 !important",
        margin: "0 !important",
        height: "30px !important",
        width: "30px !important",
        minWidth: "0 !important",
        position: "relative",
        transition: "all 0.2s",
      },
      cardButtonIcon: {
        margin: "0 !important",
        position: "absolute !important",
        top: "50% !important",
        left: "50% !important",
        transform: "translate(-50%, -50%)",
        width: "18px !important",
        height: "18px !important",
        color: "#FFFFFF",
      },
      iconButtonCustom: {
        cursor: "pointer",
        "&:hover": {
          color: cColor,
        },
      },
      floatingCard: {
        position: "fixed",
        top: 0,
        left: "50%",
        transform: "translateX(-50%)",
        zIndex: 1200,
        backgroundColor: "#fff",
        boxShadow: "0 1px 2px rgba(0,0,0,0.05)",
        borderRadius: "0 0 8px 8px",
        padding: "6px 4px 4px 10px",
        display: "flex",
        alignItems: "center",
        gap: "10px",
        maxWidth: "90%",
        [theme.breakpoints.down("sm")]: {
          position: "static",
          alignItems: "center",
          maxWidth: "100%",
          transform: "none",
          zIndex: 1200,
          borderRadius: 0,
          margin: "-40px 15px 37px 0",
          backgroundColor: "#EEEE",
          borderBottom: "1px solid " + grayColor[4],
          boxShadow: "none",
        },
      },
      floatingCardTitle: {
        fontSize: "14px",
        color: "#333",
        marginRight: "10px",
        [theme.breakpoints.down("sm")]: {
          fontSize: "12px",
        },
      },
      cardBody: {
        flex: 1,
        overflow: "auto",
        padding: "0.9375rem 20px",
        fontSize: "0.8rem",
        lineHeight: "1.5",
        color: "#3C3C3C",
      },
      textStyle: {
        fontFamily: "inherit",
        fontSize: "0.8rem",
        lineHeight: "1.5",
        color: "#3C3C3C",
      },
      filterPlaceholder: {
        backgroundColor: "#f5f5f5",
        border: "2px dashed #ccc",
        borderRadius: "8px",
        padding: "8px 20px",
        textAlign: "center",
        color: "#999",
        fontSize: "0.9rem",
        fontWeight: "500",
      },
    };
  }

  return (
    <div>
      {/* Render the floating card */}
      {renderFloatingCard()}
      <GridContainer
        spacing={1}
        style={{ marginTop: "-40px", overflow: "hidden" }}
      >
        {/* ========== OVERVIEW TABLE ========== */}
        <GridItem xs={12} sm={12} md={6} style={{ marginTop: "0px" }}>
          <Card style={{ height: "38vh" }}>
            <CardHeader color="client" icon>
              <CardIcon color="client">
                <Visibility />
              </CardIcon>
              <h4 className={classes.cardIconTitle}>
                {t("whatshappening.cards_title.overview")}
                {viewModeOverview === "table" && (
                  <>
                    {" "}
                    - <b>{t("whatshappening.cards_title.table")}</b>
                  </>
                )}
                {viewModeOverview === "stages" && (
                  <>
                    {" "}
                    - <b>{t("whatshappening.cards_title.stages")}</b>
                  </>
                )}
                {viewModeOverview === "drilldown" && (
                  <>
                    {" "}
                    - <b>{t("whatshappening.cards_title.drilldown")}</b>
                  </>
                )}
              </h4>
              <div
                style={{
                  position: "absolute",
                  right: "0px",
                  top: "10px",
                  zIndex: 1000,
                }}
              >
                <Tippy
                  content={
                    viewModeOverview === "table"
                      ? t("whatshappening.buttons.see_stages")
                      : viewModeOverview === "stages"
                        ? t("whatshappening.buttons.view_drilldown")
                        : t("whatshappening.buttons.view_table")
                  }
                  arrow={true}
                  theme="light"
                >
                  <Button
                    color="client"
                    size="sm"
                    variant="outlined"
                    onClick={toggleViewModeOverview}
                    className={classes.cardButton}
                  >
                    <FontAwesomeIcon
                      icon={
                        viewModeOverview === "table"
                          ? faFilter
                          : viewModeOverview === "stages"
                            ? faChartSimple
                            : faTable
                      }
                      className={classes.cardButtonIcon}
                    />
                  </Button>
                </Tippy>
              </div>
            </CardHeader>
            {isLoading ? (
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  height: "100%",
                }}
              >
                <ThreeDots
                  color={clientColor}
                  height={80}
                  width={80}
                  ariaLabel="loading"
                />
              </div>
            ) : (
              <CardContent
                style={{
                  flex: 1,
                  padding: 0,
                  overflow: "hidden",
                  height: "calc(38vh - 60px)",
                  position: "relative",
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                 <PerfectScrollbar
                   style={{ width: "100%", height: "100%" }}
                   options={{ suppressScrollX: false }}
                 >
                   <OverviewTableV3
                     selectedSection={selectedSection}
                     viewModeOverview={viewModeOverview}
                     kpiOverviewData={kpiOverviewData}
                     stageChoices={stageChoices}
                     unit={kpiOverviewData?.[0]?.kpiUnit || ""}
                     showUnitBefore={true}
                     onInitiativeClick={handleInitiativeClick}
                     initiativeDetailsOpen={isInitiativeDrawerOpen}
                   />
                 </PerfectScrollbar>
              </CardContent>
            )}
          </Card>
        </GridItem>

        {/* ========== KEY MESSAGES ========== */}
        <GridItem xs={12} sm={12} md={3} style={{ display: "flex", marginTop: "0px" }}>
          <Card style={{ flex: 1, height: "38vh" }}>
            <CardHeader color="client" icon>
              <CardIcon color="client">
                <Announcement />
              </CardIcon>
              <h4 className={classes.cardIconTitle}>
                {t("whatshappening.cards_title.program_key_messages")}
              </h4>
            </CardHeader>
            {isLoading ? (
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  height: "100%",
                }}
              >
                <ThreeDots
                  color={clientColor}
                  height={80}
                  width={80}
                  ariaLabel="loading"
                />
              </div>
            ) : (
              <CardBody
                className={classes.cardBody}
                style={{
                  flex: 1,
                  overflow: "auto",
                }}
              >
                <PerfectScrollbar>
                  {sections.find((s) => s.id === selectedSectionId)
                    ?.keyMessage ? (
                    <div
                      dangerouslySetInnerHTML={{
                        __html: sections.find((s) => s.id === selectedSectionId)
                          ?.keyMessage,
                      }}
                      className={classes.textStyle}
                    />
                  ) : (
                    <p style={{ color: "#999", fontSize: "0.9rem", textAlign: "center" }}>
                      {t("whatshappening.messages.no_message_available")}
                    </p>
                  )}
                </PerfectScrollbar>
              </CardBody>
            )}
          </Card>
        </GridItem>

        {/* ========== DECISIONS NEEDED ========== */}
        <GridItem xs={12} sm={12} md={3} style={{ display: "flex", marginTop: "0px" }}>
          <Card style={{ flex: 1, height: "38vh" }}>
            <CardHeader color="client" icon>
              <CardIcon color="client">
                <FontAwesomeIcon icon={faExclamationTriangle} />
              </CardIcon>
              <h4 className={classes.cardIconTitle}>
                {t("whatshappening.cards_title.decisions_needed")}
              </h4>
            </CardHeader>
            <CardBody
              className={classes.cardBody}
              style={{
                flex: 1,
                overflow: "auto",
              }}
            >
              {isLoading ? (
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    height: "100%",
                  }}
                >
                  <ThreeDots
                    color={clientColor}
                    height={100}
                    width={80}
                    ariaLabel="loading"
                  />
                </div>
              ) : (
                <PerfectScrollbar>
                  {decisions
                    .filter((dec) => dec.section_id === selectedSectionId)
                    .sort((a, b) => {
                      const priorityOrder = { High: 1, Medium: 2, Low: 3 };
                      return (
                        priorityOrder[a.priority] - priorityOrder[b.priority]
                      );
                    })
                    .map((d) => {
                      const initiative = initiatives.find(
                        (i) => String(i.id) === String(d.initiative_id)
                      );
                      return (
                        <div
                          key={d.id}
                          style={{
                            marginBottom: "0px",
                            borderBottom: "1px solid #ccc",
                            paddingBottom: "0px",
                          }}
                        >
                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                              gap: "8px",
                            }}
                          >
                            {getPriorityChip(d.priority, clientColor)}
                            <strong
                              className={classes.textStyle}
                              style={{
                                color: clientColor,
                              }}
                            >
                              {initiative
                                ? initiative.name
                                : t("whatshappening.labels.program_related")}
                            </strong>
                            <FormControlLabel
                              control={
                                <Checkbox
                                  checked={d.done}
                                  onChange={(e) =>
                                    handleDecisionToggle(d.id, e.target.checked)
                                  }
                                  icon={
                                    <RadioButtonUnchecked
                                      style={{ color: "#aaa" }}
                                    />
                                  }
                                  checkedIcon={
                                    <CheckCircle
                                      style={{ color: clientColor }}
                                    />
                                  }
                                />
                              }
                              style={{ marginTop: "0px" }}
                            />
                          </div>
                          <div
                            className={classes.textStyle}
                            style={{
                              fontWeight: "bold",
                              margin: "4px 0",
                            }}
                          >
                            {d.decisionTitle}
                          </div>
                          <div
                            className={classes.textStyle}
                            style={{
                              color: "#3C3C3C",
                            }}
                          >
                            {d.decisionDescription}
                          </div>
                        </div>
                      );
                    })}
                  {decisions.filter(
                    (dec) => dec.section_id === selectedSectionId
                  ).length === 0 && (
                    <p style={{ color: "#999", fontSize: "0.9rem", textAlign: "center" }}>
                      {t("whatshappening.messages.no_decisions")}
                    </p>
                  )}
                </PerfectScrollbar>
              )}
            </CardBody>
          </Card>
        </GridItem>

        {/* ========== GRÁFICO 1 - SAVING SG&A (FULL WIDTH) ========== */}
        <GridItem xs={12} sm={12} md={12} style={{ marginTop: "-5px" }}>
          <Card style={{ height: "38vh" }}>
            <CardHeader color="client" icon>
              <CardIcon color="client">
                <Assessment />
              </CardIcon>
              <h4 className={classes.cardIconTitle}>
                {t("whatshappening.cards_title.graph1_placeholder") || "GRÁFICO 1 [placeholder]"}
              </h4>
              <div
                style={{
                  position: "absolute",
                  right: "40px",
                  top: "10px",
                  zIndex: 1000,
                  display: "flex",
                  alignItems: "center",
                  gap: "8px",
                }}
              >
                <Tippy
                  content={
                    <span
                      dangerouslySetInnerHTML={{
                        __html: formatThresholds(mainKPI),
                      }}
                    />
                  }
                  theme="light"
                >
                  <Info
                    style={{
                      fontSize: "18px",
                      color: "#666",
                      cursor: "pointer",
                    }}
                  />
                </Tippy>
                <Tippy
                  content={
                    timeAggGraph1 === "monthly"
                      ? t("whatshappening.buttons.view_yearly")
                      : t("whatshappening.buttons.view_monthly")
                  }
                  arrow={true}
                  theme="light"
                >
                  <Button
                    color="client"
                    size="small"
                    variant="outlined"
                    onClick={toggleTimeAggGraph1}
                    className={classes.cardButton}
                  >
                    <FontAwesomeIcon
                      icon={
                        timeAggGraph1 === "monthly"
                          ? faCalendarPlus
                          : faCalendarMinus
                      }
                      className={classes.cardButtonIcon}
                    />
                  </Button>
                </Tippy>
              </div>
              <div
                style={{
                  position: "absolute",
                  right: "0px",
                  top: "10px",
                  zIndex: 1000,
                }}
              >
                <Tippy
                  content={
                    viewModeGraph1 === "chart"
                      ? t("whatshappening.buttons.view_table")
                      : t("whatshappening.buttons.view_chart")
                  }
                  arrow={true}
                  theme="light"
                >
                  <Button
                    color="client"
                    size="small"
                    variant="outlined"
                    onClick={toggleViewModeGraph1}
                    className={classes.cardButton}
                  >
                    <FontAwesomeIcon
                      icon={
                        viewModeGraph1 === "chart" ? faTable : faChartLine
                      }
                      className={classes.cardButtonIcon}
                    />
                  </Button>
                </Tippy>
              </div>
            </CardHeader>
            {isLoading || isLoadingKpisFromFilter ? (
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  height: "100%",
                }}
              >
                <ThreeDots
                  color={clientColor}
                  height={80}
                  width={80}
                  ariaLabel="loading"
                />
              </div>
            ) : (
              <CardBody
                style={{
                  flex: 1,
                  overflow: "hidden",
                  marginTop: "-20px",
                  marginBottom: "-10px",
                }}
              >
                {chartDataGraph1 ? (
                  <MultiSeriesLineChartvBAR
                    timeAgg={timeAggGraph1}
                    viewMode={viewModeGraph1}
                    data={chartDataGraph1}
                    thresholdsConfig={mainKPI?.thresholdsConfig}
                    unit={mainKPI?.unit || ""}
                    showUnitBefore={true}
                    rawData={kpiOverviewData}
                    trackingMode={mainKPI?.trackingMode || "normal"}
                    showFilters={true}
                    selectedBranch={chartFilterBranch}
                    selectedWorkfront={chartFilterWorkfront}
                    onBranchChange={setChartFilterBranch}
                    onWorkfrontChange={setChartFilterWorkfront}
                  />
                ) : (
                  <p style={{ color: "#999", fontSize: "0.9rem" }}>
                    {t("whatshappening.messages.data_unavailable")}
                  </p>
                )}
              </CardBody>
            )}
          </Card>
        </GridItem>


      </GridContainer>

      {/* ========== INITIATIVE DETAILS DIALOG ========== */}
      <InitiativeDetailsDialog
        isOpen={isInitiativeDrawerOpen}
        onClose={() => setIsInitiativeDrawerOpen(false)}
        selectedInitiative={selectedInitiative}
        isLoadingInitiativeDetail={isLoadingInitiativeDetail}
        clientColor={clientColor}
        classes={classes}
        t={t}
        userDetails={userDetails}
        customStyles={customStyles}
        selectedTabIndex={selectedTabIndex}
        setSelectedTabIndex={setSelectedTabIndex}
        initiativeKpisData={initiativeKpisData}
        isKpiLoading={isKpiLoading}
        kpiError={kpiError}
        currentOnePage={currentOnePage}
        isLoadingOnePage={isLoadingOnePage}
        onePageError={onePageError}
      />

      {/* ========== AI ASSISTANT ========== */}
      <AIAssistant
        key={isAssistantOpen ? "open" : "closed"}
        classes={classes}
        t={t}
        clientColor={clientColor}
        isOpen={isAssistantOpen}
        onToggle={handleToggleAssistant}
      />
    </div>
  );
}

